import * as Sentry from '@sentry/react';
import { SENTRY_DSN } from 'constants/env';

const initSentry = () => {
  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.VITE_NODE_ENV,
      maxBreadcrumbs: 50,
      normalizeDepth: 5,
      autoSessionTracking: true,
    });
  }
};

export default initSentry;
